module.exports = __webpack_public_path__ + "static/media/map-pin-grey.3729ecad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/map-pin-grey.svg
// module id = 2195
// module chunks = 0